/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { FC } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { ClientStatisticsReportReference } from '@DigitaleDoerfer/digitale-doerfer-api';
import StatisticsReportDownloadButton from './StatisticsReportDownload';

interface StatisticsViewProps {
	statisticsReferences: ClientStatisticsReportReference[];
}

const StatisticsView: FC<StatisticsViewProps> = ({ statisticsReferences }: StatisticsViewProps) => {
	const TimeUnitGermanNames = new Map<string, string>([
		['DAYS', 'Täglich'],
		['WEEKS', 'Wöchentlich'],
		['MONTHS', 'Monatlich']
	]);

	return (
		<>
			<TableContainer component={Paper}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Dateiname</TableCell>
							<TableCell>Zeiteinheit</TableCell>
							<TableCell>Download</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{statisticsReferences.map(row => (
							<TableRow key={row.name} hover={true}>
								<TableCell>{row.name}</TableCell>
								<TableCell>{TimeUnitGermanNames.get(row.timeUnit) || row.timeUnit}</TableCell>
								<TableCell>
									<StatisticsReportDownloadButton buttonText="CSV" fileName={row.fileNameCsv} />
									<StatisticsReportDownloadButton buttonText="Readme" fileName={row.fileNameCsvMetadata} />
									<StatisticsReportDownloadButton buttonText="TXT" fileName={row.fileNameText} />
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};

export default StatisticsView;
